import { jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { Box } from "@zillow/constellation-10";
import { resolveSpacing } from "@zillow/zrs-cms";
const BlockSpacer = ({
  attrs,
  index
}) => {
  const {
    paddingTop = {
      default: "lg",
      lg_lte: "md",
      sm_lte: "sm"
    }
  } = attrs;
  const resolvedPaddingTop = resolveSpacing(paddingTop);
  const cssProps = css.raw({
    paddingTop: resolvedPaddingTop
  });
  return /* @__PURE__ */ jsx(Box, { "data-testid": "spacer", css: cssProps }, index);
};
export {
  BlockSpacer as default
};
